import { PeriodUnit } from 'components/CustomRepeatEvery/CustomRepeatEvery';

export interface CreateUpdateLoyaltyGroupData {
	name: string;
	numbers: Array<string>;
}

export interface AddSubscription {
	msisdn?: string;
	groupId?: number;
	numbers: string[];
	date: string;
	value: number;
	repeat?: {
		startDate: string;
		endDate?: string;
		recurrenceType: PeriodUnit;
		recurrenceNumber: string;
	};
	services?: string[];
}

export interface CreateOsmInteractionData {
	subcategory: string;
	type: string;
	fullName: string;
	message: string;
	category: string;
	contactInfo: string;
	accountCode: string;
	assignmentGroup: string;
	contactNumber: string;
	customerEmail: string;
	attachments?: any;
}

export interface EsimData {
	msisdn: string;
	otp: string;
}

export interface EsimQr {
	msisdn: string;
	email: string;
	serialNumber?: string;
}

export function addSubscription({ msisdn, groupId, numbers, date, value, repeat, services }: AddSubscription) {
	return {
		paymentType: msisdn ? 'MASTER_NUMBER' : 'CREDIT_CARD',
		msisdn,
		groupId,
		type: services ? 'SERVICES' : 'TOP_UP',
		numbers,
		topUp: {
			date,
			value,
			repeat,
		},
		services,
	};
}

export interface CreateOfflinePayment {
	customer: {
		fullName: string;
		contactNumber: string;
		accountId: string;
		type: string;
	};
	bankAccount: {
		bankName: string;
		accountNumber: string;
	};
	description: string;
	excelFile: any;
	proofFile1: any;
}

export interface GetInteractions {
	limit: number;
	skip: number;
	dateFrom: string | null;
	dateTo: string | null;
	accountId: string | null;
	eventCode: string[] | null;
	upId: string | null;
	interactionIds?: number[];
}

export interface GetUserRequests {
	limit: number;
	skip: number;
}

export interface UpdateUserRequest {
	userReqId: number;
	status: string;
}
export interface ChangeTariffPlanRequest {
	recipientMsisdn: string;
	productsToAdd: string[];
	productsToDelete: string[];
}

export interface SimDtoRequest {
	msisdn: string;
	serialNo: string | null;
	otp?: string;
}

export enum SimType {
	DATA_SIM = 'data-sim',
	SAWA_SIM = 'sawa-sim',
}

export enum CardType {
	SIM,
	ESIM,
}

export interface ReplaceSimRequest {
	msisdn: string;
	serialNo: string;
	oldSerialNo: string;
}

export interface UnsubscribeNumber {
	loyaltySubscriptionId: number;
	loyaltyNumberId: number;
}

export interface CreateBillingRequest {
	period: string;
}
